import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DgPasswordPolicyWrapperService {
  constructor(private http: HttpClient) {}

  getPasswordPolicies() {
    return this.http.get(`/security/password-policy`).pipe(
      map((response: any) => response?.data),
      catchError((error) => {
        throw error;
      })
    );
  }

  validateAsyncValidations(
    dataForPost: {
      userName: string;
      newPassword: string;
      pwdPolicyKey: string;
      saltKey: string;
      className: string;
    },
    isPrelogin: boolean
  ) {
    const url = isPrelogin
      ? `/security/forgot-password/validate-password`
      : `/security/validate-password`;
    return this.http.post(url, dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => {
        throw error;
      })
    );
  }
}
